/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-top-floor.vue?vue&type=template&id=4642a8dc&scoped=true"
import script from "./pc-top-floor.vue?vue&type=script&lang=js"
export * from "./pc-top-floor.vue?vue&type=script&lang=js"
import style0 from "./pc-top-floor.vue?vue&type=style&index=0&id=4642a8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642a8dc",
  null
  
)

export default component.exports